import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';
import { Button } from 'ui-components/components/button';

import style from './style.module.less';

const FailedCostReviewBatchNotification = ({ onRetry }) => {
  return (
    <BannerMessageV2
      content={
        <>
          <FormattedMessage
            defaultMessage='An error has occurred.'
            description='error message for timeout in batch cost review click below to retry.'
            id='cTDywv'
          />
          <Button className={style['retry-button']} onClick={onRetry} theme='link'>
            Retry Cost Review
          </Button>
        </>
      }
      status={BannerStatus.Error}
    />
  );
};

FailedCostReviewBatchNotification.propTypes = {
  onRetry: PropTypes.func.isRequired,
};

export default FailedCostReviewBatchNotification;
